import React, { useId } from "react";
import PropTypes from "prop-types";
import { Drawer, Box } from "@mui/material";

ModalSp.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  children: PropTypes.node,
  footer: PropTypes.node,
  paperSx: PropTypes.object,
  bodySx: PropTypes.object,
};

export default function ModalSp({
  open,
  onClose,
  header,
  children,
  footer,
  paperSx,
  bodySx,
}) {
  const modalTitleId = useId();

  const resolvedHeader =
    typeof header === "function" ? header({ modalTitleId }) : header;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      sx={(theme) => ({ zIndex: theme.zIndex.modal + 1 })}
      ModalProps={{ keepMounted: true }}
      PaperProps={{
        role: "dialog",
        "aria-labelledby": modalTitleId,
        sx: {
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          height: "100vh",
          paddingTop: 3,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          ...paperSx,
        },
      }}
    >
      {resolvedHeader && (
        <Box sx={{ position: "sticky", top: 0, zIndex: 20, bgcolor: "#fff" }}>
          {resolvedHeader}
        </Box>
      )}

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          px: 3,
          pt: 1.5,
          bgcolor: "#fff",
          ...bodySx,
        }}
      >
        {children}
      </Box>

      {footer && <Box sx={{ px: 3, py: 2 }}>{footer}</Box>}
    </Drawer>
  );
}